import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { purgeWorkspaceQuizzes } from '../../../api/workspaces/quizzes/purgeWorkspaceQuizzes';

export function usePurgeWorkspaceQuizzes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: purgeWorkspaceQuizzes,
    onSettled: (_data, _error, { workspaceId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.allQuizzes(workspaceId)
      );
    },
  });
}
